import {
    Box,
    Flex,
    Grid,
    Spinner,
    Text,
} from "@chakra-ui/react";

import {
    useEffect,
    useState,
} from "react";

import {
    useNavigate,
} from "react-router-dom";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";
import HelpTopicsSkeleton from "./components/HelpTopicsSkeleton";
import PageHeader from "../Dashboard/components/PageHeader";

import HelpTopicHero from "./components/HelpTopicHero";
import HelpTopicCard from "./components/HelpTopicCard";

import FAQSupportCard from "../FAQ/components/FAQSupportCard";

import SupportTicketModal from "../Support/components/SupportTicketModal";

import {
    fetchHelpTopicsAction,
} from "../../state/actions/helpTopicActions";

import routes from "../../routes";
import QuickLinks from "../../components/QuickLinks";

import ResourceDocumentDialog from "../../components/ResourceDocumentDialog";
import RegisterDriverModal from "../RegisterDriver/RegisterDriverModal";
import {
    fetchResources,
} from "../../state/actions/resourceActions";
import { Eye, FileText, UserPlus } from "lucide-react";

const BASE_URL =
    process.env
        .REACT_APP_API_BASE_URL;

const HelpTopics = () => {
    const navigate =
        useNavigate();
    const [showSkeleton, setShowSkeleton] =
    useState(true);
    const dispatch =
        useDispatch();

    const [
        search,
        setSearch,
    ] = useState("");

    const [
        open,
        setOpen,
    ] = useState(false);

    const {
        helpTopics,
        loading,
    } = useSelector(
        (
            state
        ) =>
            state.helpTopic
    );
    const [
    isAffidavitOpen,
    setIsAffidavitOpen,
] = useState(false);
const [
    isRegisterDriverOpen,
    setIsRegisterDriverOpen,
] = useState(false);


const {
    resources,
    loading: resourcesLoading,
} = useSelector(
    state => state.resources
);
const {
    driverPartner,
} = useSelector(
    state => state.driverPartner
);

useEffect(() => {
    dispatch(fetchHelpTopicsAction(1, 50));

    const timer = setTimeout(() => {
        setShowSkeleton(false);
    }, 3000);

    return () => clearTimeout(timer);
}, [dispatch]);

useEffect(() => {
    dispatch(fetchResources());
}, [dispatch]);
const affidavitResource =
    resources?.find(
        resource =>
            resource.title ===
            "Mogoma Driver Affidavit Template"
    );
const handleOpenAffidavit = () => {
    if (
        resourcesLoading ||
        !affidavitResource
    ) {
        return;
    }

    setIsAffidavitOpen(true);
};
const canRegisterDriver =
    driverPartner?.status === "Approved";

    const filteredTopics =
        helpTopics
            .filter(
                (
                    topic
                ) =>
                    topic.category ===
                    "Driver Partner"
            )
            .filter(
                (
                    topic
                ) =>
                    topic.title
                        ?.toLowerCase()
                        .includes(
                            search.toLowerCase()
                        ) ||
                    topic.description
                        ?.toLowerCase()
                        .includes(
                            search.toLowerCase()
                        ) ||
                    topic.category
                        ?.toLowerCase()
                        .includes(
                            search.toLowerCase()
                        )
            );
    if (showSkeleton) {
    return (
       <Flex
    h="100vh"
    bg="#F8FAFC"
    overflow="hidden"
    marginBottom={{
        base: 20,
        md: 0,
    }}
>
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <HelpTopicsSkeleton />
                </Box>
            </Flex>
        </Flex>
    );
}
    return (
       <Flex
    h="100vh"
    bg="#F8FAFC"
    overflow="hidden"
    marginBottom={{
        base: 20,
        md: 0,
    }}
>
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <PageHeader
                        title="Help Center"
                        subtitle="Browse support articles, guides and frequently asked questions."
                    />

                    <HelpTopicHero
                        search={search}
                        setSearch={
                            setSearch
                        }
                    />
             <QuickLinks
    links={[
        ...(canRegisterDriver
            ? [
                  {
                      id: "register-driver",
                      title: "Register Driver",
                      icon: (
                          <UserPlus
                              size={20}
                              color="#2453FF"
                          />
                      ),
                      actionLabel: "Register",
                      actionIcon: UserPlus,
                      onClick: () =>
                          setIsRegisterDriverOpen(
                              true
                          ),
                  },
              ]
            : []),

        {
            id: "driver-affidavit",
            title: "Driver Affidavit Template",
            icon: (
                <Eye
                    size={20}
                    color="#2453FF"
                />
            ),
            actionLabel: "View",
            actionIcon: Eye,
            disabled:
                resourcesLoading ||
                !affidavitResource,
            onClick:
                handleOpenAffidavit,
        },
    ]}
/>

                    {loading ? (
                        <Flex
                            justify="center"
                            align="center"
                            py={20}
                        >
                            <Spinner
                                size="lg"
                                color="#2453FF"
                            />
                        </Flex>
                    ) : (
                        <>
                            <Grid
                                mt={8}
                                templateColumns={{
                                    base: "1fr",
                                    md: "1fr 1fr",
                                    xl: "repeat(3, 1fr)",
                                }}
                                gap={6}
                            >
                                {filteredTopics.map(
                                    (
                                        topic
                                    ) => (
                                        <HelpTopicCard
                                            key={
                                                topic.topic_id
                                            }
                                            topic={{
                                                ...topic,
                                                image:
                                                    topic.image
                                                        ? `${BASE_URL}/${topic.image}`
                                                        : null,
                                            }}
                                            onClick={() =>
                                                navigate(
                                                    routes.helpTopicDetails.replace(
                                                        ":topic_id",
                                                        topic.topic_id
                                                    ),
                                                    {
                                                        state:
                                                            {
                                                                topic:
                                                                    {
                                                                        ...topic,
                                                                        image:
                                                                            topic.image
                                                                                ? `${BASE_URL}/${topic.image}`
                                                                                : null,
                                                                    },
                                                            },
                                                    }
                                                )
                                            }
                                        />
                                    )
                                )}
                            </Grid>

                            {!filteredTopics.length && (
                                <Box
                                    py={20}
                                    textAlign="center"
                                >
                                    <Text
                                        color="gray.500"
                                    >
                                        No help topics found.
                                    </Text>
                                </Box>
                            )}
                        </>
                    )}

                    <FAQSupportCard
                        onOpen={() =>
                            setOpen(
                                true
                            )
                        }
                    />
                </Box>
            </Flex>
            <RegisterDriverModal
                open={isRegisterDriverOpen}
                onClose={() =>
                    setIsRegisterDriverOpen(false)
                }
            />

            <ResourceDocumentDialog
                isOpen={isAffidavitOpen}
                onClose={() =>
                    setIsAffidavitOpen(false)
                }
                resource={affidavitResource}
                title="Mogoma Driver Affidavit Template"
                description="Review the affidavit template before downloading."
                downloadFileName="Mogoma Driver Affidavit Template.docx"
            />
                        <SupportTicketModal
                isOpen={open}
                onClose={() =>
                    setOpen(
                        false
                    )
                }
            />
        </Flex>
    );
};

export default HelpTopics;